module.exports = __webpack_public_path__ + "static/media/circulo-purple.80dee919.svg";